<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										MONTHLY CUSTOMER BALANCE
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button
										@click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon
											:icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter
										:form="form"
										@filterAction="filterTable"
										:filter="filter"></report-filter>
									<b-button
										@click="printPDF"
										class="me-2 btn-sm akkurate-green-btn akkurate-small"
										><font-awesome-icon
											:icon="['fas', 'print']"
									/></b-button>
									<b-button
										@click="downloadPDF"
										class="btn-sm akkurate-green-btn akkurate-small"
										><font-awesome-icon
											:icon="['fas', 'download']"
									/></b-button>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row" ref="pdfContent">
								<div class="col-12 col-md-12">
									<statement-institution
										:institution="institution"
										:title="'MONTHLY CUSTOMER BALANCE '"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list }}
									</div>
								</div>
								<div class="col-12 col-md-12 trans_details">
									<!-- <b-table :items="items" :fields="fields" striped responsive="sm" :per-page="perPage"
                    :busy.sync="isBusy" :current-page="currentPage" small>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
</b-table> -->
									<table
										class="table table-bordered"
										v-for="(item, index) in items"
										:key="index">
										<thead>
											<tr>
												<th width="20%" scope="col">
													Account Number
												</th>
												<th width="20%" scope="col">
													Customer Name
												</th>
												<th width="20%" scope="col">
													Product Type
												</th>
												<th width="20%" scope="col">
													Branch
												</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<th width="20%" scope="row">
													{{ item.account_number }}
												</th>
												<td width="20%">
													{{ item.customer_name }}
												</td>
												<td width="20%">
													{{ item.account_type }}
												</td>
												<td width="20%">
													{{ item.branch_id }}
												</td>
											</tr>
											<tr>
												<th width="20%" scope="col">
													Date
												</th>
												<th width="20%" scope="col">
													Total Deposit
												</th>
												<th width="20%" scope="col">
													Total Withdrawal
												</th>
												<th width="20%" scope="col">
													Net
												</th>
											</tr>
											<tr
												v-for="(
													item, index
												) in item.monthly_transactions"
												:key="index">
												<td width="20%">
													{{ item.month }}
												</td>
												<td width="20%">
													{{
														displayNumber(
															item.total_deposits
														)
													}}
												</td>
												<td width="20%">
													{{
														displayNumber(
															item.total_withdrawals
														)
													}}
												</td>
												<td width="20%">
													{{
														displayNumber(
															item.net_change
														)
													}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="d-flex justify-content-between">
								<b-pagination
									class="mt-1"
									@change="navigatePage"
									v-model="currentPage"
									:total-rows="totalRecords"
									:per-page="perPage"
									aria-controls="member-table"></b-pagination>
								<div class="col text-end mt-1 akkurate-dark">
									<div>
										{{ currentPage }} - {{ perPage }} of
										{{ totalRecords }}
									</div>
									<b-form-group
										label="Per Page"
										label-size="sm"
										class="mb-0">
										<b-form-select
											@change="selectPerPage"
											id="per-page-select"
											v-model="perPage"
											:options="per_page_options"
											size="sm"></b-form-select>
									</b-form-group>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"
			><i class="fas fa-angle-up"></i
		></a>
	</div>
</template>
<script>
	import SidebarView from "@/views/main/components/Sidebar.vue";
	import TopbarView from "@/views/main/components/Topbar.vue";
	import Footer from "@/views/main/components/Footer.vue";
	import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
	import ApiService from "@/core/services/api.service";
	import Multiselect from "vue-multiselect";
	import html2pdf from "html2pdf.js";
	import ExcelJS from "exceljs";
	import ReportFilter from "../form/ReportFilter.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
	export default {
		components: {
			SidebarView,
			TopbarView,
			Footer,
			StatementInstitution,
			Multiselect,
			ReportFilter,
			ChatBot,
		},
		data() {
			return {
				form: {
					start_date: this.getBeginningOfYear(),
					end_date: new Date().toISOString().substr(0, 10),
					branches: [],
					products: [],
					branch_options: [],
					product_options: [],
					users: [],
					users_options: [],
					status: [],
					coa: [],
					coa_options: [],
					terms: "",
					terms_options: ["YTD", "Periodic"],
					categories: [],
					loan_status:[],
				},
				filter: {
					branches: true,
					products: true,
					start_date: true,
					end_date: true,
					condition: false,
					terms: true,
					coa: false,
					voucher_status: false,
					loan_status:false,
				},
				search: "Search",
				isBusy: false,
				isSearching: false,
				per_page_options: ["10", "20", "50", "100"],
				per_page_selected: "10",
				currentPage: 1,
				perPage: 10,
				isLoadingInstitution: false,
				institution: "",
				branch_list: "",
				items: [],
				totalRecords: 0,
			};
		},
		computed: {
			rows() {
				return this.items.length;
			},
		},

		created() {
			this.getInstitution();
			this.getproductBalance();
		},
		methods: {
			navigatePage(index) {
				this.isBusy = true;
				this.currentPage = index;
				this.getproductBalance();
			},
			selectPerPage(index) {
				this.perPage = index;
				this.getproductBalance();
			},
			async getproductBalance() {
				this.items = [];
				this.isBusy = true;
				this.search = "Processing...";
				this.isSearching = true;
				await ApiService.post(
					"/reports/controls/customer/product/differences",
					{
						page: this.currentPage,
						per_page: this.perPage,
						start_date: this.form.start_date,
						end_date: this.form.end_date,
						product: this.form.products.map((index) => {
							return index.id;
						}),
						branch: this.form.branches.map((index) => {
							return index.id;
						}),
						term: this.form.terms,
					}
				)
					.then((response) => {
						this.isBusy = false;
						this.search = "Search";
						this.isSearching = false;
						const res = response.data?.data;
						this.items = res;
						this.totalRecords = response.data.meta.total;
					})
					.catch((error) => {
						this.isBusy = false;
						this.search = "Search";
						this.isSearching = false;
						console.log(error);
					})
					.finally((error) => {
						this.isBusy = false;
						this.search = "Search";
						this.isSearching = false;
						console.log(error);
					});
			},
			downloadPDF() {
				const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
				const pdfOptions = {
					margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
					filename: "statement.pdf",
					image: { type: "jpeg", quality: 0.98 },
					html2canvas: { scale: 2 },

					jsPDF: {
						unit: "in",
						format: "letter",
						orientation: "portrait",
					},
				};
				html2pdf()
					.from(content)
					.set(pdfOptions)
					.toPdf()
					.get("pdf")
					.then((pdf) => {
						var totalPages = pdf.internal.getNumberOfPages();
						var insit_name = this.institution.name;
						var insit_tele = this.institution.telephone;
						var insit_email = this.institution.email;
						var insit_motto = this.institution.motto;

						for (var i = 1; i <= totalPages; i++) {
							pdf.setPage(i);
							pdf.setFontSize(8);
							pdf.setTextColor(150);
							pdf.text(
								[
									"For Inquiries, Please Contact " +
										insit_name +
										", Customer Service on " +
										insit_tele +
										"",
									"or email us on " +
										insit_email +
										" " +
										insit_motto +
										"",
									"Page " + i + " of " + totalPages,
								],
								pdf.internal.pageSize.getWidth() / 2,
								pdf.internal.pageSize.getHeight() - 0.6,
								{ align: "center" }
							);
						}
					})
					.save();
			},
			printPDF() {
				const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
				const pdfOptions = {
					margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
					filename: "statement.pdf",
					image: { type: "jpeg", quality: 0.98 },
					html2canvas: { scale: 2 },

					jsPDF: {
						unit: "in",
						format: "letter",
						orientation: "portrait",
					},
				};
				html2pdf()
					.from(content)
					.set(pdfOptions)
					.toPdf()
					.get("pdf")
					.then((pdf) => {
						var totalPages = pdf.internal.getNumberOfPages();
						var insit_name = this.institution.name;
						var insit_tele = this.institution.telephone;
						var insit_email = this.institution.email;
						var insit_motto = this.institution.motto;

						for (var i = 1; i <= totalPages; i++) {
							pdf.setPage(i);
							pdf.setFontSize(8);
							pdf.setTextColor(150);
							pdf.text(
								[
									"For Inquiries, Please Contact " +
										insit_name +
										", Customer Service on " +
										insit_tele +
										"",
									"or email us on " +
										insit_email +
										" " +
										insit_motto +
										"",
									"Page " + i + " of " + totalPages,
								],
								pdf.internal.pageSize.getWidth() / 2,
								pdf.internal.pageSize.getHeight() - 0.6,
								{ align: "center" }
							);
						}
						// Get the blob of the PDF
						return pdf.output("blob");
					})
					.then((pdfBlob) => {
						// Create a URL for the PDF blob
						var pdfUrl = URL.createObjectURL(pdfBlob);

						// Open the URL in a new tab
						const printWindow = window.open(
							pdfUrl,
							"_blank",
							"width=800,height=600"
						);
						printWindow.onload = () => {
							printWindow.print();
							URL.revokeObjectURL(pdfUrl);
						};
					})
					.catch((error) => {
						console.error("Error generating PDF:", error);
					});
			},
			filterTable() {
				this.getproductBalance();
			},
			changePerPageNumber(data) {
				this.perPage = data;
				this.getproductBalance();
			},
			async getInstitution() {
				this.isLoadingInstitution = true;
				await ApiService.get("/settings/institution")
					.then((response) => {
						this.institution = response.data.data;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.isLoadingInstitution = false;
					});
			},
			async generateExcel() {
				const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
				const imageUrl = "/default_logo.png"; // Path to your image file

				// Institution details
				const institutionName = this.institution.name;
				const institutionMotto = this.institution.motto;
				const institutionAddress = this.institution.address;
				const institutionPhone = this.institution.telephone;
				const institutionEmail = this.institution.email;
				try {
					// Fetch the Excel file from the public URL
					const response = await fetch(fileUrl);
					if (!response.ok) {
						throw new Error(
							`Network response was not ok: ${response.statusText}`
						);
					}
					const arrayBuffer = await response.arrayBuffer();

					// Load the file into ExcelJS
					const wb = new ExcelJS.Workbook();
					await wb.xlsx.load(arrayBuffer);

					// Access the first sheet
					const ws = wb.getWorksheet(1); // Get the first worksheet

					// Add Image to the top of the sheet
					const imageResponse = await fetch(imageUrl);
					const imageBuffer = await imageResponse.arrayBuffer();
					const imageId = wb.addImage({
						buffer: imageBuffer,
						extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
					});

					// Insert the image at the top-left corner (row 1, column 1)
					ws.addImage(imageId, {
						tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
						ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
					});

					// Insert institution details next to the image (starting at row 1, col 5)
					const institutionDetailsStartCol = 5; // Column where text starts after image
					const institutionDetailsRow = 1; // Row for institution details

					// Add the institution name, address, and phone number
					ws.getCell(`I${institutionDetailsRow}`).value =
						institutionName;
					ws.getCell(`I${institutionDetailsRow}`).font = {
						bold: true,
						size: 14,
					}; // Bold and bigger font for name

					ws.getCell(`I${institutionDetailsRow + 1}`).value =
						institutionAddress;
					ws.getCell(`I${institutionDetailsRow + 1}`).font = {
						size: 12,
					}; // Regular font size for address

					ws.getCell(`I${institutionDetailsRow + 2}`).value =
						institutionMotto;
					ws.getCell(`I${institutionDetailsRow + 2}`).font = {
						size: 12,
					}; // Regular font size for phone

					ws.getCell(`I${institutionDetailsRow + 3}`).value =
						institutionPhone;
					ws.getCell(`I${institutionDetailsRow + 3}`).font = {
						size: 12,
					}; // Regular font size for phone

					ws.getCell(`I${institutionDetailsRow + 4}`).value =
						institutionEmail;
					ws.getCell(`I${institutionDetailsRow + 4}`).font = {
						size: 12,
					}; // Regular font size for phone

					// Optionally adjust the column width if the text is long
					ws.getColumn("H").width = 100; // Adjust the width of column D (if necessary)

					// Define header row
					const header = [
						"Account Number",
						"Customer Name",
						"Product Type",
						"Branch",
						"Date",
						"Total Deposits",
						"Total Withdraws",
						"Net",
					];

					// Add header row starting from row 13 (or the next row after the image and details)
					const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
					let headerRow = ws.getRow(startingRow);
					headerRow.values = header;
					headerRow.font = { bold: true };
					headerRow.commit(); // Commit the row to the worksheet

					// Add individual data rows
					let currentRow = startingRow + 1;

					// Process each item
					this.items.forEach((item) => {
						const row = ws.getRow(currentRow);
						// Map item values to the corresponding header columns
						row.values = [
							item.account_number,
							item.customer_name,
							item.account_type,
							item.balance_1d,
							item.monthly_transactions[0].month,
							item.monthly_transactions[0].total_deposits,
							item.monthly_transactions[0].total_withdrawals,
							item.monthly_transactions[0].net_change,
						];
						row.commit();
						currentRow++;
					});

					const buffer = await wb.xlsx.writeBuffer();
					const blob = new Blob([buffer], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
					});

					// Create a download link and simulate a click to download the file
					const link = document.createElement("a");
					link.href = URL.createObjectURL(blob);
					link.download = "Modified_REPORT_TEMPLATE.xlsx";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} catch (err) {
					console.error(
						"Error fetching, modifying, or downloading the Excel file:",
						err.message
					);
				}
			},
		},
	};
</script>
